import { styled } from '@sparky/stitches';

export const SplitViewItemWrapper = styled('div', {
  overflow: 'hidden',
  picture: {
    display: 'flex',
  },
});
